const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Dominio raiz de la plataforma; las tiendas cuelgan como subdominio.
export const TURNSTILE_SITEKEY = process.env.REACT_APP_TURNSTILE_SITEKEY || '0x4AAAAAAFAKvzPPGuPpmB5B';

export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || 'tenora.tech';

export const config = {
  URL_API: isLocalhost ? "http://localhost:7001/api" : "/api",
  URL_PUBLIC: isLocalhost ? "http://localhost:7001/public" : "/public",
  URL_SOCKET: "http://localhost:5000"
};